<div class="text-left">
  <!-- <div class="selectYear"><b>Year</b></div> -->
  <div class="relative">
    <input type="date" placeholder="Employee name / ID" min="2022-01-01" id="expesnseDate" class="w-100 m-100" style="padding: 2px 15px;">
  </div>
</div>